module.exports = __webpack_public_path__ + "img/home_image_2.a1aee29a.png";